import DialogEditor from 'projectSections/elements/DialogEditor'
import ContractTemplateEditor from 'projectSections/sections/proposal/ContractTemplateEditor'
import { ProposalDataType } from 'types/proposals'

type ContractTemplateEditorDialogConfig = {
  selectedTemplate: {
    id: number
    org: string
  }
}

export const ContractTemplateEditorDialog = ({
  isOpen,
  handleClose,
  config,
  proposalData,
}: {
  isOpen: boolean
  handleClose: () => void
  config: ContractTemplateEditorDialogConfig
  proposalData: ProposalDataType
}) => {
  return (
    <DialogEditor
      // @ts-ignore
      isOpen={isOpen}
      handleClose={handleClose}
      id={config.selectedTemplate?.id}
      editorComponent={<ContractTemplateEditor handleChange={() => {}} />}
      editorProps={{ templateOwner: config?.selectedTemplate.org === proposalData?.org?.url }}
    />
  )
}
